import moment from 'moment'
import { DATE_FORMAT } from 'Rentlio/utils/dateFormatEnum'

export const getPrepaymentDate = (arrival, daysBeforeArrival) => {
  return arrival.clone().hours(0).subtract(daysBeforeArrival, 'days').format(DATE_FORMAT)
}

// In calculating prepayment date if the daysBeforeArrival is 0 that means the prepayment date is at the time of the booking
export const getTodaysDate = () => moment().hours(0).format(DATE_FORMAT)
